(() => {
  if (window.wlyEmailSignupReady) return;
  window.wlyEmailSignupReady = true;
  const wlyKlaviyoSubscribe = async (wlyCompany, wlyList, wlyEmail, wlySource) => {
    const wlyResponse = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(wlyCompany)}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision: '2024-10-15',
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: wlySource || 'Website',
            profile: { data: { type: 'profile', attributes: { email: wlyEmail } } },
          },
          relationships: { list: { data: { type: 'list', id: wlyList } } },
        },
      }),
    });
    if (!wlyResponse.ok) throw new Error(`Klaviyo ${wlyResponse.status}`);
  };
  document.addEventListener('click', (event) => {
    const wlyClose = event.target.closest('[data-wly-signup-popup-close]');
    const wlyDialog = wlyClose ? wlyClose.closest('[data-wly-signup-popup]') : (event.target.matches && event.target.matches('[data-wly-signup-popup]') ? event.target : null);
    if (wlyDialog && wlyDialog.open) wlyDialog.close();
  });
  document.addEventListener('click', (event) => {
    const wlyReset = event.target.closest('[data-wly-signup-reset]');
    if (!wlyReset) return;
    const wlySuccess = wlyReset.closest('[data-wly-signup-success]');
    const wlyForm = wlySuccess && wlySuccess.parentElement.querySelector('[data-wly-signup]');
    if (!wlyForm) return;
    wlySuccess.hidden = true;
    wlyForm.hidden = false;
    const wlyInput = wlyForm.querySelector('input[type="email"]');
    if (wlyInput) {
      wlyInput.value = '';
      wlyInput.focus();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches && event.target.matches('[data-wly-signup-popup]')) document.documentElement.classList.remove('wly-sp-open');
  }, true);
  document.addEventListener('submit', async (event) => {
    const wlyForm = event.target.closest('[data-wly-signup]');
    if (!wlyForm) return;
    const wlyCompany = wlyForm.dataset.wlyKlaviyoCompany;
    const wlyList = wlyForm.dataset.wlyKlaviyoList;
    if (!wlyCompany || !wlyList) return;
    event.preventDefault();
    const wlyInput = wlyForm.querySelector('input[type="email"]');
    const wlyButton = wlyForm.querySelector('[data-wly-signup-button]');
    const wlyError = wlyForm.querySelector('[data-wly-signup-error]');
    const wlySuccess = wlyForm.parentElement.querySelector('[data-wly-signup-success]');
    if (!wlyInput || !wlyInput.checkValidity()) {
      wlyInput?.reportValidity();
      return;
    }
    if (wlyError) wlyError.hidden = true;
    wlyButton?.setAttribute('aria-busy', 'true');
    if (wlyButton) wlyButton.disabled = true;
    try {
      await wlyKlaviyoSubscribe(wlyCompany, wlyList, wlyInput.value.trim(), wlyForm.dataset.wlyKlaviyoSource);
      const wlyPopup = wlyForm.dataset.wlySignupPopupId ? document.getElementById(wlyForm.dataset.wlySignupPopupId) : null;
      if (wlyPopup && typeof wlyPopup.showModal === 'function') {
        wlyInput.value = '';
        document.documentElement.classList.add('wly-sp-open');
        wlyPopup.showModal();
      } else if (wlySuccess) {
        const wlyEmailSlot = wlySuccess.querySelector('[data-wly-signup-email]');
        if (wlyEmailSlot) wlyEmailSlot.textContent = wlyInput.value.trim();
        wlyForm.hidden = true;
        wlySuccess.hidden = false;
        wlySuccess.setAttribute('tabindex', '-1');
        wlySuccess.focus();
      } else {
        wlyInput.value = '';
      }
      document.dispatchEvent(new CustomEvent('wly:signup', { detail: { list: wlyList } }));
    } catch (wlyErr) {
      if (wlyError) wlyError.hidden = false;
    } finally {
      wlyButton?.removeAttribute('aria-busy');
      if (wlyButton) wlyButton.disabled = false;
    }
  });
})();
